<sc-master-detail [data]="stationGroup?.stationSets" [selection]="[selectedStationSet]" [readOnly]="true" [level]="2"
    [readOnly]="true" (selectionChanged)="onSelectionChanged($event);" [allowUnselect]="true">
    <app-station-set-details [stationSet]="selectedStationSet" [context]="selectionContext" *ngIf="selectedStationSet">
    </app-station-set-details>
</sc-master-detail>
